module.exports = __webpack_public_path__ + "static/img/search.1aa64b3f.png";